module.exports = __webpack_public_path__ + "img/icon-category-camper-bg.77ea5d38.jpg";